import React from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import { QueueKey } from 'flow/types/EntityKeys';

import useAppContext from 'flow/hooks/useAppContext';
import IconButton from 'flow/components/ui-components/IconButton';
import Icon from 'flow/components/ui-components/Icon';
import { SortableHandle } from 'react-sortable-hoc';
import DragHandleIcon from '@mui/icons-material/DragHandle';

const DragHandle = SortableHandle(() => <DragHandleIcon />);
interface Props {
    queueKey: QueueKey;
    onClickDelete: (key: QueueKey) => void;
}

const QueueDraggable = ({ onClickDelete, queueKey }: Props) => {
    const { i18next } = useAppContext();

    const queue = useAppSelector((state) =>
        state.pbx.getIn(['queues', queueKey]),
    );

    return (
        <div
            className="flex w-full items-center justify-between"
            key={`draggable-${queueKey}`}
        >
            <div className="flex text-sm text-gray-800">
                {queue ? queue.get('description') : i18next.t('status.unknown')}
            </div>
            <div className="flex items-center gap-x-3 ps-3">
                <IconButton
                    onClick={() => onClickDelete(queueKey)}
                    aria-label={i18next.t('remove')}
                >
                    <Icon iconKey={'delete'} className="fill-gray-500" />
                </IconButton>
                <div className="cursor-pointer">
                    <DragHandle />
                </div>
            </div>
        </div>
    );
};

export default React.memo(QueueDraggable);
